
const enums = { 'JETPRINT_FULFILLMENT': { 'text': 'jetprint', 'value': 1 },
  'MERCHANT_UPLOAD': { 'text': '商户上传的', 'value': 3 },
  'OLD_JETPRINT_FULFILLMENT': { 'text': '旧的jetprint', 'value': 2 }}
export default enums
